import { vehicleOwnershipTypes } from "helpers/enums";
import { requiredField } from "helpers/validators";
import { optionalVehicleCapacity } from "helpers/vehicles/ownership";
import { selectList as counterpartiesList } from "sources/books/cargoOwners";
import { list as legalPersonsList } from "sources/books/legalPersons";

const documentConfig = {
    name: {
        label: "Наименование документа",
        inputProps: { name: "name", maxLength: 256 },
        validators: [requiredField],
        required: true,
    },
    number: {
        label: "Номер документа",
        inputProps: { name: "number", maxLength: 256 },
        validators: [requiredField],
        required: true,
    },
    date: {
        label: "Дата документа",
        inputProps: { name: "date", type: "date" },
        inPortal: true,
    },
    externalId: {
        label: "Идентификатор документа",
        inputProps: { name: "externalId", maxLength: 256 },
    },
    additionalInfo: {
        label: "Дополнительные сведения",
        inputProps: { name: "additionalInfo", maxLength: 2048 },
        textarea: true,
    },
    legalPersonId: {
        label: "Первая сторона",
        inputProps: { name: "legalPersonId" },
        url: legalPersonsList,
        propName: "name",
        menuPortalTarget: document.body,
    },
    counterpartyId: {
        label: "Вторая сторона",
        inputProps: { name: "counterpartyId" },
        url: counterpartiesList,
        filterPropName: ["name", "inn"],
        propName: ({ name, inn }) => (inn ? `${name} (${inn})` : name),
        menuPortalTarget: document.body,
        validators: [requiredField],
        required: true,
    },
};

const vehicleOwnershipConfig = {
    carrying: {
        label: "Грузоподъёмность, т",
        inputProps: { name: "carrying", inputMode: "decimal", autoComplete: "off" },
        validators: [optionalVehicleCapacity],
    },
    volume: {
        label: "Вместимость, м³",
        inputProps: { name: "volume", inputMode: "decimal", autoComplete: "off" },
        validators: [optionalVehicleCapacity],
    },
    ownershipType: {
        label: "Тип владения",
        inputProps: { name: "ownershipType" },
        options: vehicleOwnershipTypes,
        menuPortalTarget: document.body,
    },
    ownershipBasisDocuments: {
        value: [],
        config: documentConfig,
    },
};

export { documentConfig, vehicleOwnershipConfig };
